import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { LOCAL_STORAGE_CONSTANT } from '../constants/localstorage.constant';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {
  private envVersion =  environment.version.split('.').slice(0, 2).join('.');
  private readonly withoutVersionKeysList = [
    LOCAL_STORAGE_CONSTANT.LAST_VERIFIED_OTP_ID
  ];

  get(key: string): string {
    // Added separate case for keys which doesn't requires _ and version in localstorage
    if (this.withoutVersionKeysList.includes(key)) {
      // Fetch value for both with and without version, first preference will
      // be given to without version key value
      const woVersion = window.sessionStorage.getItem(key);
      const wVersion = window.sessionStorage.getItem(key + '_' + this.envVersion);
      return woVersion || wVersion;
    } else {
      return window.sessionStorage.getItem(key + '_' + this.envVersion);
    }
  }

  set(key: string, value: string): void {
    // Added separate case for keys which doesn't requires _ and version in localstorage
    if (this.withoutVersionKeysList.includes(key)) {
      // will not use versioning, if present it will be removed and without version will be set
      window.sessionStorage.removeItem(key + '_' + this.envVersion);
      window.sessionStorage.setItem(key, value);
    } else {
      window.sessionStorage.setItem(key + '_' + this.envVersion, value);
    }
  }

  remove(key: string): void {
    window.sessionStorage.removeItem(key + '_' + this.envVersion);

    if (this.withoutVersionKeysList.includes(key)) {
      window.sessionStorage.removeItem(key);
    }
  }

  clear(): void {
    window.sessionStorage.clear();
  }
}
